import React from 'react';
import { Label as FlowBiteLabel, LabelProps as FlowBiteLabelProps } from 'flowbite-react';
import { labelTheme } from '../../styles/themes/label';

export interface LabelProps {
    testId?: string;
    color?: FlowBiteLabelProps['color'];
    disabled?: FlowBiteLabelProps['disabled'];
    value?: FlowBiteLabelProps['value'];
    componentId?: string;
}
export const Label: React.FC<LabelProps> = (props) => {
    const { testId, color, disabled, value, componentId } = props;
    return (
        <FlowBiteLabel
            data-testid={testId}
            theme={labelTheme}
            htmlFor={componentId}
            color={color}
            disabled={disabled}
            value={value}
        />
    );
};
